import React from 'react';
import PropTypes from 'prop-types';
import { IllustrationPill } from '../IllustrationPill';
import { StyledIllustrationPills, Grid } from './styles.js';

export const IllustrationPills = ({ pills, backgroundColor }) => {
  return (
    <StyledIllustrationPills $backgroundColor={backgroundColor}>
      <Grid>
        {pills.map((pill, i) => (
          <IllustrationPill key={i} {...pill} />
        ))}
      </Grid>
    </StyledIllustrationPills>
  );
};

IllustrationPills.displayName = 'IllustrationPills';

IllustrationPills.propTypes = {
  pills: PropTypes.arrayOf(PropTypes.object.isRequired).isRequired,
  backgroundColor: PropTypes.string,
};
